<template>
  <div class="btn-wrapper" :style="wrapperStyle">
    <div class="btn" @click="onButtonClick" :style="buttonStyle">
      {{label}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    getProps: {
      type: Function,
      default: () => null
    }
  },

  data: function() {
    const props = this.getProps();
    
    return {
      buttonStyle: {},
      wrapperStyle: {},
      ...props,
    }
  },

  methods: {
    onButtonClick: function() {
      this.onClick(this.row);
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    display: inline-block;
    width: auto;
    background-color: $vis-primary-color;
    color: #FFF;
    font-size: 13px;
    padding: 6px 8px;
    line-height: 1.1;
    height: auto;
    border-radius: 0;

    &:hover {
      opacity: 0.8;
    }
  }
</style>